export const queryStackChart = `query MyQuery {
    getDateTimebyDate(date: $date, limit: 17) {
      items {
        statusesHour {
          items {
            successOrder
            dateTime {
              dateTime
            }
          }
        }
      }
    }
  }`

export const queryListOfDriver = `query MyQuery {
  getDateTimebyDateTime(dateTime: $date) {
    items {
      latesDriverDaily {
        items {
          notLate
          late
          driverName
          origin
        }
      }
      latesDaily {
        items {
          late
          notLate
        }
      }
    }
  }
}
`
export const queryLateHourly = `query MyQuery {
  getDateTimebyDate(date: $date) {
    items {
      dateTime
      latesDaily {
        items {
          notLate
          late
        }
      }
      latesHour {
        items {
          notLate
          late
        }
      }
    }
  }
}
`
export const queryHourlyStatus = `query MyQuery {
  getDateTimebyDate(date: $date) {
    items {
      dateTime
      statusesHour {
        items {
          successOrder
          progressOrder
          issue
          activeDriver
        }
      }
    }
  }
}
`

export const queryExpressSLA = `query MyQuery {
  getExpressSLA(date: $date) {
    date
    data
    createdAt
    updatedAt
  }
}`
